/* src/app/request-form/default-responsible-site-information-modal/default-responsible-site-information-modal.component.scss */
.modal-header {
  font-family:
    "Roboto",
    Tahoma,
    Helvetica,
    sans-serif;
  border-bottom: none;
}
.modal-header h4 {
  font-size: 32px;
}
.modal-title {
  padding-left: 35px;
}
.modal-body {
  min-height: 36px;
  font-size: 14px;
  padding-left: 35px;
  padding-bottom: 20px;
  padding-right: 20px;
  font-weight: 400;
}
.modal-footer {
  padding-top: 30px;
  padding-bottom: 10px;
  border-top: none;
}
.btn {
  margin-top: 28px;
  height: 36px;
  border-radius: 100px;
  border: 0;
  padding-right: 28px;
  padding-left: 28px;
  font-size: 13px;
}
.btn-green {
  color: white;
  background-color: #00857D;
}
.btn-close {
  padding-right: 40px !important;
}
/*# sourceMappingURL=default-responsible-site-information-modal.component.css.map */
